import { render, staticRenderFns, recyclableRender, components } from "./index.vue?vue&type=template&id=edc1a520&scoped=true&"
var renderjs
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=edc1a520&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc1a520",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/van-three-slide/index.vue"
export default component.exports